<div class='e-btn-group' [formGroup]="form">
  <input type="radio" id="{{id}}-yes" formControlName="formValue" [value]="true"/>
  <label class="e-btn" for="{{id}}-yes">{{ 'i18n.shared.yes' | translate}}</label>
  <input type="radio" id="{{id}}-no" formControlName="formValue" [value]="false"/>
  <label class="e-btn" for="{{id}}-no">{{ 'i18n.shared.no' | translate}}</label>
</div>
